import { backend_client } from "../../../helpers/api";

const convertToUTCStringRemoveZ = (date) => {
  return date.toISOString().replace("Z", "");
};

const changeExamAvailability = (examInstanceId, until) => {
  const convertionDate = convertToUTCStringRemoveZ(until);
  const endpoint = `/exam-instances/${examInstanceId}/available-until`;
  const payload = {
    available_until: convertionDate,
  };
  return backend_client.patch(endpoint, payload);
};

export default changeExamAvailability;
